"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var rsManagementRouter = {
  path: '/rsManagement',
  component: _layout.default,
  redirect: '/rsManagement/goodsList',
  name: 'rsManagement',
  meta: {
    title: '多商户相关',
    icon: 'clipboard'
  },
  children: [{
    path: 'storeList',
    name: 'storeList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/storeList'));
      });
    },
    meta: {
      title: '店铺列表管理',
      icon: ''
    }
  }, {
    path: 'storeCategory',
    name: 'storeCategory',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/storeCategory'));
      });
    },
    meta: {
      title: '店铺商品类目管理',
      icon: ''
    }
  }, {
    path: 'businessType',
    name: 'businessType',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/businessType/index.vue'));
      });
    },
    meta: {
      title: '业务类型管理',
      icon: ''
    }
  }, {
    path: 'goodsCategory',
    name: 'goodsCategory',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/goodsCategory'));
      });
    },
    meta: {
      title: '商品类目管理',
      icon: ''
    }
  }, {
    path: 'goodsLabel',
    name: 'goodsLabel',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/goodsLabel'));
      });
    },
    meta: {
      title: '商品标签管理',
      icon: ''
    }
  }, {
    path: 'goodsBrand',
    name: 'goodsBrand',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/goodsBrand'));
      });
    },
    meta: {
      title: '商品品牌管理',
      icon: ''
    }
  }, {
    path: 'goodsAttrs',
    name: 'goodsAttrs',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/goodsAttrs'));
      });
    },
    meta: {
      title: '商品规格管理',
      icon: ''
    }
  }, {
    path: 'goodsList',
    name: 'goodsList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/goodsList/index.vue'));
      });
    },
    meta: {
      title: '商品列表',
      icon: ''
    }
  }, {
    path: 'goodsAdd',
    name: 'goodsAdd',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/goodsList/add.vue'));
      });
    },
    meta: {
      title: '新增商户商品',
      icon: ''
    },
    hidden: true
  }, {
    path: 'goodsEdit/:id',
    name: 'goodsEdit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/goodsList/add.vue'));
      });
    },
    meta: {
      title: '编辑商户商品',
      icon: ''
    },
    hidden: true
  }, {
    path: 'deliverySetting',
    name: 'deliverySetting',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/deliverySetting/index.vue'));
      });
    },
    meta: {
      title: '配送设置',
      icon: ''
    }
  }, {
    path: 'receiptTemplate',
    name: 'receiptTemplate',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/receiptTemplate/index.vue'));
      });
    },
    meta: {
      title: '小票打印配置',
      icon: ''
    }
  }, {
    path: 'receiptTemplate/edit/:id',
    name: 'receiptTemplateEdit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/receiptTemplate/editor.vue'));
      });
    },
    meta: {
      title: '编辑小票模板',
      icon: ''
    },
    hidden: true,
    beforeEnter: function beforeEnter(to, from, next) {
      if (to.params.id === 'new') {
        to.meta.title = to.query.copyFrom ? '复制小票模板' : '新增小票模板';
      } else {
        to.meta.title = '编辑小票模板';
      }
      next();
    }
  }, {
    path: 'merchantOrderList',
    name: 'merchantOrderList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/orderList/index.vue'));
      });
    },
    meta: {
      title: '外卖订单',
      icon: ''
    }
  },
  //酒店订单
  {
    path: 'hotelOrderList',
    name: 'hotelOrderList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/orderList/index.vue'));
      });
    },
    meta: {
      title: '酒店订单',
      icon: ''
    }
  }, {
    path: 'merchantOrderList2',
    name: 'merchantOrderList2',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/orderList2/index.vue'));
      });
    },
    meta: {
      title: '外卖订单-商户',
      icon: ''
    }
  }, {
    path: 'tgOrderList',
    name: 'tgOrderList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/tgOrderList/index.vue'));
      });
    },
    meta: {
      title: '团购订单',
      icon: ''
    }
  }, {
    path: 'expressOrderList',
    name: 'expressOrderList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/expressOrderList/index.vue'));
      });
    },
    meta: {
      title: '快递订单',
      icon: ''
    }
  }, {
    path: 'expressSetting',
    name: 'expressSetting',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rsManagement/expressSetting/index.vue'));
      });
    },
    meta: {
      title: '快递运费模板配置',
      icon: ''
    }
  }]
};
var _default = exports.default = rsManagementRouter;